<template>
	<div class="rb-timeline-bar" :style="style">
		<slot></slot>
	</div>
</template>

<script>
	const minValue = 0.005;

	export default {
		name: 'RbPlayerTimelineBar',
		props: {
			start: {
				type: Number,
				default: 0
			},
			end: {
				type: Number,
				default: 0
			},
			duration: {
				type: Number,
				required: true
			}
		},
		computed: {
			widthRatio() {
				let value = (this.end - this.start) / this.duration;
				value = Math.floor(value * 1000)/1000;

				return Math.max(value, minValue);
			},
			leftPercent() {
				return (this.start/this.duration) * 100;
			},
			style() {
				return {
					transform: `translate(${this.leftPercent}%, -50%) scale(${this.widthRatio}, 1)`
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.rb-timeline-bar {
		position: absolute;
		top: 50%;
		transform-origin: 0 center;
		transition: transform .3s ease;

		left: 0;
		right: 0;
		height: 2px;
	}
</style>
